var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramStories(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.323 16.848a7.803 7.803 0 0 0 5.43.707.622.622 0 1 1 .283 1.21 9.058 9.058 0 0 1-6.3-.82.62.62 0 1 1 .587-1.097zM9.979 1C14.953 1 19 5.037 19 10a9.047 9.047 0 0 1-4.393 7.727.62.62 0 0 1-.854-.214.62.62 0 0 1 .214-.852 7.8 7.8 0 0 0 3.788-6.66c0-4.278-3.488-7.759-7.776-7.759A.622.622 0 1 1 9.98 1zM2.423 11.836a7.727 7.727 0 0 0 2.21 3.797.62.62 0 0 1-.428 1.072.62.62 0 0 1-.428-.17 8.966 8.966 0 0 1-2.564-4.406.623.623 0 0 1 1.21-.292zM11.973 5A3.03 3.03 0 0 1 15 8.026v3.948A3.03 3.03 0 0 1 11.974 15H8.026A3.03 3.03 0 0 1 5 11.974V8.026A3.03 3.03 0 0 1 8.026 5zM10 7.368A2.635 2.635 0 0 0 7.368 10 2.635 2.635 0 0 0 10 12.632 2.635 2.635 0 0 0 12.632 10 2.635 2.635 0 0 0 10 7.368zM10 8.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zM2.625 5.905a.62.62 0 0 1 .301.825 7.678 7.678 0 0 0-.684 2.497.622.622 0 0 1-1.239-.122 8.92 8.92 0 0 1 .795-2.9.623.623 0 0 1 .827-.3zM12.5 7a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zM4.802 3.25a.62.62 0 0 1 .06.877c-.05.057-.098.114-.146.172a.622.622 0 0 1-.962-.788c.056-.067.112-.134.17-.2a.623.623 0 0 1 .878-.06z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramStories);
export default __webpack_public_path__ + "static/media/instagram-stories.713af4130b0f1f07e0f0290ab47939f4.svg";
export { ForwardRef as ReactComponent };